import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { LOGO_URL } from "@/lib/brand";

function formatError(detail) {
  if (!detail) return "Erro ao processar a solicitação.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company_name: "" });
  const [busy, setBusy] = useState(false);
  const setF = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Conta criada com sucesso!");
      nav("/app");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-emerald-950 text-white">
        <Link to="/" className="inline-block bg-white/95 p-3 w-fit" data-testid="register-back-link">
          <img src={LOGO_URL} alt="Sollute Ocupacional" className="h-14 w-auto" />
        </Link>
        <div>
          <h2 className="font-display text-5xl font-extrabold tracking-tight leading-tight">
            Comece em<br/>cinco minutos.
          </h2>
          <p className="text-emerald-100/80 mt-6 max-w-md">
            Cadastre sua empresa, gere o link anônimo e veja os resultados consolidados em tempo real.
          </p>
        </div>
        <div className="text-xs text-emerald-200/60">© 2026 Sollute Ocupacional</div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <div className="overline mb-2">Conta gratuita</div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900 mb-8 tracking-tight">Criar conta</h1>

          <label className="label">Nome completo</label>
          <input required value={form.name} onChange={setF("name")} className="input mb-4" data-testid="register-name-input" />

          <label className="label">E-mail corporativo</label>
          <input type="email" required value={form.email} onChange={setF("email")} className="input mb-4" data-testid="register-email-input" />

          <label className="label">Senha (mín. 6 caracteres)</label>
          <input type="password" required minLength={6} value={form.password} onChange={setF("password")} className="input mb-4" data-testid="register-password-input" />

          <label className="label">Empresa (opcional)</label>
          <input value={form.company_name} onChange={setF("company_name")} className="input mb-6" data-testid="register-company-input" />

          <button disabled={busy} className="btn btn-primary w-full justify-center" data-testid="register-submit-button">
            {busy ? <i className="fa-solid fa-circle-notch fa-spin"></i> : <i className="fa-solid fa-user-plus"></i>}
            Criar conta
          </button>

          <div className="mt-6 text-sm text-slate-600">
            Já tem conta?{" "}
            <Link to="/login" data-testid="register-to-login-link" className="text-emerald-900 font-semibold hover:underline">Entrar</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
